import { Injectable, ViewChild } from "@angular/core";
import { ELanguages } from "@core/enums/Languages.enum";
import { TranslateService } from "@ngx-translate/core";
import { NewDatatableComponent } from "@shared/datatable/new-datatable.component";
import { PrimeNGConfig } from "primeng/api";

export interface Locale {
  lang: string;
  data;
}

const LOCALIZATION_LOCAL_STORAGE_KEY = "language";

@Injectable({
  providedIn: "root",
})
export class TranslationService {
  @ViewChild(NewDatatableComponent) datatableComponent!: NewDatatableComponent;

  private langIds: string[] = [];

  constructor(
    private translate: TranslateService,
    private config: PrimeNGConfig
  ) {
    this.translate.setDefaultLang(ELanguages.UZ_CYRL);
  }

  loadTranslations(...args: Locale[]): void {
    const locales = [...args];

    locales.forEach((locale) => {
      this.translate.setTranslation(locale.lang, locale.data, true);
      this.langIds.push(locale.lang);
    });

    this.translate.addLangs(this.langIds);
    this.translate.use(this.getSelectedLanguage());
    this.translate
      .get("primeng")
      .subscribe((res) => this.config.setTranslation(res));
  }

  setLanguage(lang: string) {
    if (lang) {
      this.translate.use(this.translate.getDefaultLang());
      this.translate.use(lang);
      localStorage.setItem(LOCALIZATION_LOCAL_STORAGE_KEY, lang);
      window.location.reload();
    }
  }

  setLanguageWithoutLocationReloading(lang: ELanguages) {
    if (lang) {
      this.initLang(lang);
    }
  }

  initLang(lang: ELanguages) {
    this.translate.use(this.translate.getDefaultLang());
    this.translate.use(lang);
    localStorage.setItem(LOCALIZATION_LOCAL_STORAGE_KEY, lang);
  }

  getSelectedLanguage(): string {
    return (
      localStorage.getItem(LOCALIZATION_LOCAL_STORAGE_KEY) ||
      this.translate.getDefaultLang()
    );
  }
}
